import { Mail, Phone } from "lucide-react";
import { SiteLayout } from "../components/site/SiteLayout";

const EMAIL = "contact.wech@wechllc.com";
const PHONE = "+1 307-449-1668";

const Item = ({ href, icon, label, value, testid }) => (
  <a href={href} data-testid={testid} className="scroll-card p-6 flex gap-5 items-center hover:-translate-y-1 transition-transform">
    <span className="w-14 h-14 rounded-full bg-[var(--vermilion)] text-white flex items-center justify-center shrink-0">{icon}</span>
    <span className="min-w-0">
      <span className="block text-sm text-stone-500 font-bold">{label}</span>
      <span className="block text-xl sm:text-2xl font-black text-[var(--tea)] break-all">{value}</span>
    </span>
  </a>
);

export default function Contact() {
  return (
    <SiteLayout>
      <div className="max-w-3xl mx-auto px-6 sm:px-10 py-14 font-serif-tc" data-testid="contact-page">
        <h1 className="text-4xl sm:text-5xl font-black text-[var(--vermilion)]">聯絡我們</h1>
        <p className="text-lg text-stone-700 mt-4 leading-relaxed">有任何問題、建議，或想合作推廣中文教育，都歡迎寫信或來電，我們會盡快回覆。</p>
        <div className="grid gap-5 mt-10">
          <Item testid="contact-email-link" href={`mailto:${EMAIL}`} icon={<Mail />} label="電子郵件（點一下就能寫信）" value={EMAIL} />
          <Item testid="contact-phone-link" href={`tel:${PHONE.replace(/[^+\d]/g, "")}`} icon={<Phone />} label="聯絡電話" value={PHONE} />
        </div>
      </div>
    </SiteLayout>
  );
}
